<p-sidebar
    [(visible)]="sidebarVisible"
    class="document-sidebar"
    position="right"
    role="region"
    (onHide)="onCloseSidebar()"
    styleClass="w-30rem"
>
<p-toast></p-toast>

<div class="sidebar-content">
    <div class="tabviewContainer" >

      <!-- Documents List -->
      <p-tabView class="custom-tabview" [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">
        <p-tabPanel *ngIf="chatService?.chatType !== ESGChatType" header="Documents" class="pt-0" [disabled]="((activeChat?.chatTables?.length > 0 || chatService?.chatType === QECChatType || chatService?.chatType === ESGChatType) && activeChat) || (chatService?.chatType === ESGChatType)">
          <div class="p-input-icon-left search-container">
            <i class="pi pi-search"></i>
            <input
                type="text"
                pInputText
                [(ngModel)]="searchText"
                placeholder="Search Document"
                class="document-search"
                (keydown)="this.searchTextUpdate.next($event)"
            />
        </div>
        <div *ngIf="isloading" class="loadingContainer">
          <app-loader [isLoading]="isloading"></app-loader>
        </div>
        <div  *ngIf="!isloading && activeTabIndex ===0"
        (scroll)="scrollUpdate.next($event)"
        class="scrollContainer">
          <p-table
              class="ngTable"
              [value]="organizedDocsList"
              [(selection)]="selectedDocs"
              (onRowSelect)="onRowSelect($event)"
              (onRowUnselect)="onRowUnselect($event)"
          >
              <ng-template pTemplate="header">
                  <tr>
                      <th>
                          <p-tableHeaderCheckbox
                          ></p-tableHeaderCheckbox>
                      </th>
                      <th>Document Name</th>
                  </tr>
              </ng-template>
              <ng-template pTemplate="body" let-document let-rowIndex="rowIndex">
                  <tr>
                      <td class="nameCol cursor">
                        <p-tableCheckbox
                          [value]="document" [disabled]="
                          (document.documentStatus === documentArchived && (excelType.includes(document.contentType) || csvType.includes(document.contentType)))"
                        ></p-tableCheckbox>
                      </td>
                      <td class="cursor">
                        <div *ngIf="document.type === 'Folder'" (click)="toggleFolder(document.documentId)" class="folder-icon">
                          <i class="bi bi-folder-fill folderColor" *ngIf="!expandedFolders[document.documentId]"></i>
                          <i class="pi pi-folder-open folderColor" *ngIf="expandedFolders[document.documentId]"></i>
                          {{ document.documentName }}
                        </div>
                        <div *ngIf="document.type === 'file'">{{ document.documentName }}</div>
                      </td>
                  </tr>
                  <tr *ngIf="document.type === 'Folder' && expandedFolders[document.documentId]">
                    <td colspan="2" class="nested-files">
                      <p-table [value]="document.files" [(selection)]="selectedDocs" class="nested-table">
                        <ng-template pTemplate="body" let-file>
                          <tr>
                            <td>
                              <p-tableCheckbox [value]="file"
                              [disabled]="
                              (file.documentStatus === documentArchived && (excelType.includes(file.contentType) || csvType.includes(file.contentType)))"
                              ></p-tableCheckbox>
                            </td>
                            <td>{{ file.documentName }}</td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </td>
                  </tr>
              </ng-template>
          </p-table>
        </div>
        </p-tabPanel>

        <!-- DeltaTables List-->
        <ng-container *ngIf="chatService?.chatType !== ESGChatType">
        <p-tabPanel *availableFor header="QEC Data" [disabled]="activeChat?.chatDocument?.length > 0 || (activeChat && chatService?.chatType !== QECChatType) || (chatService?.chatType === ESGChatType)">
          <div class="p-input-icon-left search-container">
            <i class="pi pi-search"></i>
            <input
                type="text"
                pInputText
                [(ngModel)]="searchText"
                placeholder="Search Tables"
                class="document-search"
                (keydown)="this.searchTextUpdate.next($event)"
            />
        </div>
        <div *ngIf="isloadingTables" class="loadingContainer">
          <app-loader [isLoading]="isloadingTables"></app-loader>
        </div>
        <div *ngIf="!isloadingTables && activeTabIndex === 1"
           (scroll)="scrollUpdate.next($event)"
           class="scrollContainer">
          <p-table
          class="ngTable"
          [value]="deltaTablesList"
          [(selection)]="selectedTables"
      >
          <ng-template pTemplate="header">
              <tr>
                  <th>
                      <p-tableHeaderCheckbox

                      ></p-tableHeaderCheckbox>
                  </th>
                  <th>Table Name</th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-table>
              <tr>
                  <td>
                    <p-tableCheckbox
                      [value]="table"
                    ></p-tableCheckbox>
                  </td>
                  <td>{{ table.tableName }}</td>
              </tr>
          </ng-template>
      </p-table></div>
        </p-tabPanel>
      </ng-container>

        <!-- ESG List-->

        <p-tabPanel *ngIf="chatService?.chatType === ESGChatType" header="Tables" [disabled]="activeChat?.chatDocument?.length > 0 || (chatService?.chatType !== ESGChatType)">
          <div *ngIf="isloading" class="loadingContainer">
            <app-loader [isLoading]="isloading"></app-loader>
          </div>
          <div  class="scrollContainer" *ngIf="!isloading">
            <p-table
              [value]="tablesListByCategory"
              [(selection)]="selectedTables"
              (onRowExpand)="onRowExpand($event)"
              [expandedRowKeys]="expandedESGRowKeys"
              scrollHeight="calc(100vh - 280px)" dataKey="category"
            >
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th style="width: 5rem">
                  </th>
                  <th>Category</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded">
                <tr>
                  <td>
                    <p-button
                      type="button"
                      pRipple
                      class="expandRowClass"
                      [pRowToggler]="rowData"
                      [text]="true"
                      [rounded]="true"
                      [plain]="true"
                      [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                    ></p-button>
                  </td>
                  <td
                    tooltipPosition="top">
                    <span>{{ rowData.category }}</span>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="rowexpansion" let-rowData>
                <tr>
                  <td colspan="7">
                <p-table [value]="rowData.tables" *ngIf="rowData.tables.length > 0"  [(selection)]="selectedTables">
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="checkbox">
                        <p-checkbox
                          [(ngModel)]="rowData.categorySelection"
                          [binary]="true"
                          (onChange)="toggleCategorySelection($event, rowData.category, rowData.tables, rowData.categorySelection)"></p-checkbox>
                      </th>
                      <th>Table Name</th>
                      <th>Source</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-tableData>
                    <tr [pSelectableRow]="tableData.tableId">
                      <td>
                          <p-tableCheckbox
                            [value]="tableData"
                          ></p-tableCheckbox>
                      </td>
                      <td
                      tooltipPosition="top"
                          pTooltip="{{
                            tableData?.tableName | titlecase
                          }}">
                        {{ tableData.tableName.length>30 ? (tableData.tableName | slice : 0 : 28)+'...':tableData.tableName }}</td>
                      <td>{{ tableData.source }}</td>
                    </tr>
                  </ng-template>
                </p-table>
                <div *ngIf="rowData.tables.length === 0" class="flex justify-content-center align-items-center spinnerContainerESG">
                  <span class="loaderSpinner mr-2"></span>
                </div>
              </td></tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" class="emptymessage">
                <tr>
                  <td colspan="12">
                    <div class="noData">No Document Available</div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </p-tabPanel>

        <p-tabPanel *ngIf="chatService?.chatType === ESGChatType" header="Documents" [disabled]="activeChat?.chatDocument?.length > 0 || (chatService?.chatType !== ESGChatType)">
          <app-esg-filters
          [sidebarVisible]="sidebarVisible"
          [selectedTables]="selectedTables"
          (emitSelectedFilters)="checkESGFiltersEmitter($event)"
          ></app-esg-filters>
        </p-tabPanel>
      </p-tabView>

</div>
<div *ngIf="loadmoreLoading && docsList.length>0 && !isloading" class="flexEnd load-more mt-1">Loading...</div>

</div>
    <div *ngIf="!(this.chatService?.chatType === ESGChatType && this.activeTabIndex === 1)"  class="footer flex justify-content-end align-items-center">
      <span class="alertText mr-3" *ngIf="(selectedTables.length > 0 && selectedDocs.length > 0)">* Please select either Documents or QEC Data. You cannot access both simultaneously.</span>
        <button
        type="button"
        [disabled]="(activeTabIndex===0 && chatService?.chatType !== ESGChatType  && (isloading || selectedDocs.length === 0) ) || (chatService?.chatType === QECChatType && (isloadingTables ||selectedTables.length===0 )) || (selectedTables.length > 0 && selectedDocs.length > 0)  || ( chatService?.chatType === ESGChatType && (isloading ||selectedTables.length===0 || checkMultipleSourcesSelection())) "
        (click)="addDocs()"
        class="btn-sm processBtn mr-2 mt-2"
        >
       Submit
        </button>
    </div>
</p-sidebar>
